import { motion } from "framer-motion";
import { X } from "lucide-react";
import { copy } from "@/content/explordioCopy";

export const MediaLibraryModal = ({ onClose }) => {
  const closeFromBackdrop = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <motion.div className="modal-backdrop" role="presentation" onClick={closeFromBackdrop} data-testid="media-library-modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.section className="feature-modal feature-modal-detailed library-detail-modal" role="dialog" aria-modal="true" aria-labelledby="media-library-modal-title" data-testid="media-library-modal" initial={{ opacity: 0, scale: .94, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: .96, y: 8 }} transition={{ duration: .22 }}>
        <button className="modal-close" type="button" aria-label="Close media library details" onClick={onClose} data-testid="media-library-modal-close-button"><X aria-hidden="true" /></button>
        <div className="feature-modal-content">
          <h2 id="media-library-modal-title" className="modal-title" data-testid="media-library-modal-title">{copy.library.title}</h2>
          <p className="modal-description" data-testid="media-library-modal-description">{copy.library.modalDescription}</p>
          <p className="library-modal-body" data-testid="media-library-modal-body">{copy.library.modalBody}</p>
          <div className="library-detail-grid">
            <section className="library-detail-section" data-testid="media-library-storage-section">
              <h3 data-testid="media-library-storage-heading">{copy.library.storageHeading}</h3>
              <ul className="library-detail-list storage-detail-list">
                {copy.library.storageSources.map((source, index) => <li key={source} data-testid={`media-library-storage-item-${index + 1}`}>{source}</li>)}
              </ul>
            </section>
            <section className="library-detail-section" data-testid="media-library-actions-section">
              <h3 data-testid="media-library-actions-heading">{copy.library.actionsHeading}</h3>
              <ul className="library-detail-list">
                {copy.library.actions.map((action, index) => <li key={action} data-testid={`media-library-action-item-${index + 1}`}>{action}</li>)}
              </ul>
            </section>
          </div>
          <p className="modal-tagline" data-testid="media-library-modal-tagline">{copy.library.modalTagline}</p>
        </div>
      </motion.section>
    </motion.div>
  );
};